export const TICKET = 'Ticket';
export const MERCHANDISE = 'Merchandise';
export const EXPERIENCE = 'Experience';
export const VOUCHER = 'Voucher';
export const GENERIC = 'Generic';
export const PHYSICAL_MATCH_TICKETS = 'Physical_Match_Ticket';

export enum ProductTypes {
	Experience = 'Experience',
	Generic = 'Generic',
	GenericPhysical = 'Generic Physical',
	Merchandise = 'Merchandise',
	Nfts = 'Nfts',
	Physical_Match_Tickets = 'Physical_Match_Tickets',
	Ticket = 'Ticket',
	Video_Greetings = 'Video Greetings',
	Voucher = 'Voucher'
}
export type ProductTypeNames =
	| string
	| typeof EXPERIENCE
	| typeof GENERIC
	| typeof MERCHANDISE
	| typeof PHYSICAL_MATCH_TICKETS
	| typeof TICKET
	| typeof VOUCHER;

export const PASSPORT = 'Passport';
export const NATIONAL_ID = 'National ID';
export const DRIVERS_LICENSE = `Driver's License`;

export const enum ProductCheckoutErrors {
	NOT_ENOUGH_FUNDS_IN_BALANCE = 'notEnoughFundsInBalance',
	PRODUCT_BANNED_IN_USER_COUNTRY = 'productBannedInUserCountry',
	PRODUCT_NOT_ENABLED = 'productNotEnabled',
	PRODUCT_NOT_ENOUGH_STOCK = 'productNotEnoughStock',
	PRODUCT_OUT_OF_STOCK = 'productOutOfStock',
	PRODUCT_TIER_LEVEL_ACCESS_NOT_MET = 'productTierLevelAccessNotMet',
	PRODUCT_VARIANT_IS_NOT_YET_REDEEMABLE = 'productVariantIsNotYetRedeemable',
	PURCHASE_WILL_EXCEED_MAX_ALLOWED = 'purchaseWillExceedMaxAllowed',
	REQUESTED_QUANTITY_NOT_ALLOWED = 'requestQuantityNotAllowed',
	USER_MET_MAX_PURCHASE = 'userMetMaxPurchase'
}

export const ProductCheckoutErrorsEnum: Record<string, ProductCheckoutErrors> = {
	'3227a9f6-ae18-4000-9c56-0efc446d6c2c': ProductCheckoutErrors.PRODUCT_OUT_OF_STOCK,
	'344347e7-d48c-4be4-99f3-541edef4840f': ProductCheckoutErrors.REQUESTED_QUANTITY_NOT_ALLOWED,
	'565f57e7-aabc-4e60-8090-a96dbef288ca': ProductCheckoutErrors.PRODUCT_NOT_ENABLED,
	'6f9c7173-5dc2-4645-8493-98aaa20a11d4': ProductCheckoutErrors.PURCHASE_WILL_EXCEED_MAX_ALLOWED,
	'7564f987-c88b-4cc5-8990-18fe81df9d46': ProductCheckoutErrors.PRODUCT_NOT_ENOUGH_STOCK,
	'985fbf4c-b4ff-4def-b672-06808b6878c3': ProductCheckoutErrors.USER_MET_MAX_PURCHASE,
	'c3e591c7-6357-43d7-a956-57f1cdbba397': ProductCheckoutErrors.PRODUCT_BANNED_IN_USER_COUNTRY,
	'e03d057b-e451-48a3-99cb-2eae5e5a3661': ProductCheckoutErrors.PRODUCT_VARIANT_IS_NOT_YET_REDEEMABLE,
	'efdbdd2e-4668-4e41-b361-751365430492': ProductCheckoutErrors.NOT_ENOUGH_FUNDS_IN_BALANCE,
	'f844c283-8a5c-4113-927d-44f585b35967': ProductCheckoutErrors.PRODUCT_TIER_LEVEL_ACCESS_NOT_MET
};
